import { EMPLOYEE_PAY_TYPE } from '@/utils/Employee';

const TRANSFER_LIMIT_FIELDS = ['min_transfer_balance', 'monthly_transfer_limit', 'max_transfers_month'];

const isBlank = value => value === '' || value == null || Number.isNaN(value);

export const employeeHandle = {
  methods: {
    setEmployeeDefaults(employee) {
      employee.properties = employee.properties || {};
      if (!Array.isArray(employee.properties.notes)) {
        employee.properties.notes = [];
      }

      if (!employee.properties.address) {
        employee.properties.address = {};
      }

      employee.salary_properties = employee.salary_properties || {};
      employee.salary_properties.salary_or_hourly =
        employee.salary_properties.salary_or_hourly || EMPLOYEE_PAY_TYPE.HOURLY;
      employee.salary_properties.salary_period = employee.salary_properties.salary_period || 'YEAR';

      const employee_defaults = this.state.company.properties.employee_defaults || {};
      if (
        employee.max_transfer_percent === undefined &&
        employee_defaults.max_transfer_percent &&
        employee_defaults.max_transfer_percent.default
      ) {
        employee.max_transfer_percent = employee_defaults.max_transfer_percent.default;
      }

      if (employee.monthly_transfer_limit === undefined && employee_defaults.monthly_transfer_limit) {
        employee.monthly_transfer_limit = employee_defaults.monthly_transfer_limit;
      }

      return employee;
    },
    ensureNoEmptyStringsInEmployee({ clearTransferLimits = false } = {}) {
      if (isBlank(this.employee.default_wagerate)) {
        this.employee.default_wagerate = undefined;
      }
      if (isBlank(this.employee.salary_properties.salary)) {
        this.employee.salary_properties.salary = undefined;
      }
      TRANSFER_LIMIT_FIELDS.forEach(field => {
        if (clearTransferLimits && this.employee[field] === '') {
          this.employee[field] = null;
        } else if (isBlank(this.employee[field])) {
          this.employee[field] = undefined;
        }
      });
    },
  },
};
